<output
  class="bd-assistant-plan bd-body-regular"
  aria-live="polite"
  data-id="assistant-plan"
>
  <ul class="bd-assistant-plan-steps">
    @for (step of steps(); track $index) {
      <li
        class="bd-assistant-plan-step"
        [class.bd-assistant-plan-step-done]="step.state === 'done'"
        [class.bd-assistant-plan-step-active]="step.state === 'active'"
        [class.bd-assistant-plan-step-failed]="step.state === 'failed'"
        [attr.data-id]="'assistant-plan-step-' + step.state"
      >
        @switch (step.state) {
          @case ('done') {
            <i class="ui-check" aria-hidden="true"></i>
          }
          @case ('active') {
            <i
              class="ui-loading bd-assistant-plan-spinner"
              aria-hidden="true"
            ></i>
          }
          @case ('failed') {
            <i class="ui-info" aria-hidden="true"></i>
          }
          @default {
            <i class="ui-dash" aria-hidden="true"></i>
          }
        }
        <span class="sr-only">{{ step.stateLabel }}</span>
        <span class="bd-assistant-plan-step-label">{{ step.label }}</span>
      </li>
    }
  </ul>
</output>
